import { createAsyncThunk, createSelector, createSlice, } from '@reduxjs/toolkit';
import { FORM_TYPES } from '../../../types/paramsConfig.js';
import { setActiveView } from '../wrapperContext/wrapperContextSlice.js';
export const initialNavigationState = {
    navigationContext: 'none',
    activeForm: FORM_TYPES.LOGIN,
};
const navigationSlice = createSlice({
    name: 'navigationSlice',
    initialState: initialNavigationState,
    reducers: {
        /**
         * @deprecated Use setActiveWrapper instead
         */
        setNavigationContext: (state, actions) => {
            state.navigationContext = actions.payload;
        },
        /**
         * @deprecated Use setActiveView instead
         */
        setActiveForm: (state, actions) => {
            state.activeForm = actions.payload;
        },
    },
});
//TODO: rethink if this and this slice is needed
export const navigateToThunk = createAsyncThunk('formNavigation/navigate', async (formType, { dispatch }) => {
    console.log('navigateTo: ', formType);
    dispatch(setActiveView(formType));
    // we need return here in order to get fullfilled state
    return formType;
});
const navigationSelector = (state) => state.core.navigation;
export const selectNavigationContext = createSelector(navigationSelector, ({ navigationContext }) => navigationContext);
export const selectActiveForm = createSelector(navigationSelector, ({ activeForm }) => activeForm);
export const navigationActions = navigationSlice.actions;
export default navigationSlice.reducer;
//# sourceMappingURL=navigationSlice.js.map